import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/user.svg'


const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-1 mb-4" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold" }, "个人中心"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "user",
    class: "w-8 h-8"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_styled_uploader = _resolveComponent("styled-uploader")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_tabs, {
      activeKey: _ctx.activeKey,
      "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeKey) = $event)),
      type: "card"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tab_pane, {
          key: "information",
          tab: "修改个人资料"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, {
              ref: "formRef",
              model: _ctx.formState,
              name: "basic",
              "label-col": { span: 4 },
              "wrapper-col": { span: 20 },
              autocomplete: "off",
              onFinish: _ctx.onFinish
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  name: "picture",
                  "wrapper-col": { offset: 4, span: 16 }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_styled_uploader, {
                      text: "上传你的头像~",
                      "show-uploaded": "",
                      onSuccess: _ctx.updateAvatar
                    }, null, 8, ["onSuccess"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "昵称",
                  name: "nickName",
                  rules: [{ required: true, message: 'Please input your nickName!' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.formState.nickName,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.nickName) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "gender",
                  label: "性别",
                  rules: [{ required: true }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.formState.gender,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.gender) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_button, { value: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 女 ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_radio_button, { value: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 男 ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { "wrapper-col": { offset: 4, span: 16 } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      "html-type": "submit"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Submit ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "onFinish"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_tab_pane, {
          key: "worksManager",
          tab: "恢复删除作品"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 敬请期待 ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["activeKey"])
  ]))
}